// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import firebase from 'firebase/app'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(Vuex)

Vue.prototype.$axios = axios
Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyBncS0UIWXf7966MC5meSzaCnXpf-OoD_E',
  authDomain: 'danielruginets-personalwebsite.firebaseapp.com',
  databaseURL: 'https://danielruginets-personalwebsite.firebaseio.com',
  projectId: 'danielruginets-personalwebsite',
  storageBucket: 'danielruginets-personalwebsite.appspot.com',
  messagingSenderId: '126885230252',
  appId: '1:126885230252:web:4fbc3e0a90bb49b97d9109'
}

firebase.initializeApp(firebaseConfig)

let app

firebase.auth().onAuthStateChanged(user => {
  console.log('user', user)
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})



// WEBPACK FOOTER //
// ./src/main.js